import { Component, OnInit, Input } from '@angular/core';
import { RecordsService } from '../services/records.service';

@Component({
  selector: 'app-tabyaeredit',
  templateUrl: './tabyaeredit.component.html',
  styleUrls: ['./tabyaeredit.component.css']
})
export class TabyaereditComponent implements OnInit {

  public list: any;
  private link: string;
  public total: number = 0;
  @Input() set linkv(val: string) {
    this.link = val;
    this.charge(this.link);
  }

  constructor(private recordservice: RecordsService) { }
  ngOnInit(): void { }

  private charge(link: string)
  {
    this.recordservice.getFilters(link)
    .subscribe(data => {
      this.list = data;
      this.total = 0;
      for (let index = 0; index < this.list.length; index++) {
          this.total += parseInt(this.list[index]['y']);
      }
    }, err =>{
      console.log(err);
    });
  }
}
